import { SET_LOADING } from "../../actions/notification/types";

const INITIAL_STATE = {
  loading: false,
};

const NotificationReducer = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case SET_LOADING: {
      return {
        ...state,
        loading: action.payload,
      };
    }
    default: {
      return state;
    }
  }
};

export default NotificationReducer;
